import redirect from "@rill/redirect";
import set from "@rill/set";
import rill from "rill";
import Billing from "../../dashboard/settings/billing";
import Branding from "../../dashboard/settings/branding";
import CoachBilling from "../../dashboard/settings/coach-billing";
import CoachManageBilling from "../../dashboard/settings/coach-manage-billing";
import ExerciseLibrary from "../../dashboard/settings/exercise-library";
import Faqs from "../../dashboard/settings/faqs";
import GymContract from "../../dashboard/settings/gym-contract";
import GymLocations from "../../dashboard/settings/gym-locations";
import ManageCoaches from "../../dashboard/settings/manage-coaches";
import ManageCoaching from "../../dashboard/settings/manage-coaching";
import Notifications from "../../dashboard/settings/notifications";
import PerformInvoice from "../../dashboard/settings/perform-invoice";
import Preferences from "../../dashboard/settings/preferences";
import Profile from "../../dashboard/settings/profile";
import RepMaximum from "../../dashboard/settings/rep-maximum";
import Settings from "../../dashboard/settings/settings";
import SettingsMenuController from "../../dashboard/settings/settings-menu-controler";
import StorefrontScripts from "../../dashboard/settings/storefront-scripts";
import Subscription from "../../dashboard/settings/subscription";
import YourProducts from "../../dashboard/settings/your-products";

const SettingsController = (app) => {
  app.get("/settings", redirect("/coaching-portal/settings/profile")).at(
    "/settings/*",
    rill()
      .use(set("heading", ["Coaching", "Settings"]))
      .setup(SettingsMenuController)
      .setup(Settings)
      .setup(Billing)
      .setup(CoachBilling)
      .setup(CoachManageBilling)
      .setup(ManageCoaches)
      .setup(ManageCoaching)
      .setup(Notifications)
      .setup(Faqs)
      .setup(Branding)
      .setup(StorefrontScripts)
      .setup(GymContract)
      .setup(GymLocations)
      .setup(PerformInvoice)
      .setup(YourProducts)
      .setup(Profile)
      .setup(Preferences)
      .setup(RepMaximum)
      .setup(ExerciseLibrary)
      .setup(Subscription)
  );
};

export default SettingsController;
